<template>
  <v-dialog
    v-model="languageModal"
    scrollable persistent
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card class="locale-language-switcher">
      <v-card-title class="text-center font-weight-black">
        <span>{{ $t('common.change_language_label') }}</span>
        <v-spacer></v-spacer>
        <v-icon color="red" @click="closeLanguageModal()">fa-light fa-xmark</v-icon>
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item v-for="(locale,i) in languages" :key="locale.value" @click="switchLocale(i)">
            <v-list-item-content>
              <v-list-item-title class="pb-5" v-text="locale.label" />
              <v-divider></v-divider>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';

export default {
  name: 'LocaleSwitcher',
  props: {
    instance: Object,
    flatOpenModal: Boolean
  },
  data() {
    return {
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(','),
      languageModal: true,
      languages: []
    }
  },
  computed: {
    ...mapState('shared', ['lang']),
    ...mapGetters('customer',['getLabels'])
  },
  methods: {
    ...mapMutations('shared', ['setLanguage']),
    ...mapMutations('template', ['setFlatModalLenguage']),
    getLanguages() {
      const langs = this.instance.langs.map(item => item.toLowerCase());
      const language = this.instance.language.toLowerCase();
      const data = [
        ...langs,
        language
      ];
      const dataArr = new Set(data);
      const languagesArr = [...dataArr];
      languagesArr.map(item => {
        if(item === 'en') {
          this.languages.push({label: this.getLabels('switcher_label_english'), value: item});
        }else if(item === 'pt') {
          this.languages.push({label: this.getLabels('switcher_label_portuguese'), value: item});
        }else {
          this.languages.push({label: this.getLabels('switcher_label_spanish'), value: item});
        };
      });
      if(this.languages.length === 1 && (this.languages.value === language)) this.languageModal = false;
    },
    setSelectedLanguage() {
      this.selectedLang = this.instance.langs.length > 1 && this.lang !== '' ? this.languages.findIndex(item => item === this.lang) : 0;
    },
    switchLocale(index) {
      this.selectedLang = index;
      if(index !== this.instance.langs.findIndex(item => item === this.lang)) {
        this.setLanguage(this.languages[index].value);
        this.$i18n.locale = this.lang;
      };
      if(this.flatOpenModal) this.setFlatModalLenguage(2);
      else this.setFlatModalLenguage(1);
      window.location.reload();
      this.closeLanguageModal();
      
    },
    closeLanguageModal() {
      this.languageModal = false;
      this.$emit('showLanguageSelectorModal');
    }
  },
  mounted() {
    this.getLanguages();
    this.setSelectedLanguage();
  }
}
</script>

<style scoped lang="scss">
  .locale-language-switcher {
    font-family: 'Poppins', sans-serif !important;
    border-radius: 24px !important;
    text-align: center;
  }
</style>